import {useState, useEffect} from 'react';
// import './App.css';
import ProductCard from './products.js';
import OrderSummary from './ordersummary.js';
import clarity from '@microsoft/clarity';


function getSimilarity(s1, s2) {
  let longer = s1.length < s2.length ? s2 : s1;
  let shorter = s1.length < s2.length ? s1 : s2;
  if (longer.length === 0) return 1.0;
  
  const editDistance = (s1, s2) => {
    let costs = [];
    for (let i = 0; i <= s1.length; i++) {
      let lastValue = i;
      for (let j = 0; j <= s2.length; j++) {
        if (i === 0) costs[j] = j;
        else if (j > 0) {
          let newValue = costs[j - 1];
          if (s1.charAt(i - 1) !== s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
      if (i > 0) costs[s2.length] = lastValue;
    }
    return costs[s2.length];
  };

  return (longer.length - editDistance(longer, shorter)) / parseFloat(longer.length);
}
function App() {

  useEffect(() => {
    // Replace "YOUR_PROJECT_ID" with your actual ID
    clarity.init("vp35fxt807", {
      content: true,      // Allows viewing of text content on the page
      cookies: true,      // Allows tracking across sessions
      lean: false         // Ensures all features are active
    });
  }, []);

  // State to track quantities: { 1: 2, 2: 0, 3: 5 }
  const [cart, setCart] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
 
  const [activeTab, setActiveTab] = useState('ramzanpack');
  const cartdata = ()=>{
    let data="";
    let total=0;
    Object.values(cart).forEach((product) => {
    if(parseInt(product[1])>0){      
      data+=product[2] + '\t\t' + product[1] + "x\t\t" + String(parseInt(product[3]) * parseInt(product[1])) + "\n";
      total+=parseInt(product[3]) * parseInt(product[1])
    }
  
  }
  
  
  );
    data+="---------\n\t\tDelivery Charges: 100\n\t\tTotal: " + String(total+100);
    return encodeURIComponent(data);
  }
  // useEffect(()=>{console.log(cart);},[cart]);
  const updateCart = (id, quantity, title, price) => {
    setCart((prev) => ({
      ...prev,
      [id]: [id, quantity, title, price] // Prevents negative quantity

    }));


  };

const handleWhatsappClick = () => {

  if (Object.keys(cart).length === 0 || isCartEmpty) {
        alert("Please add some items before ordering.");
        return;
    }
    // 1. Send the "Lead" event to Meta
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        content_name: "SaudaMart",
        value: 1,
        currency: 'PKR' // Change to your local currency
      });
    }

    // https://wa.me/923359018136?text=" + cartdata()
    window.open(`https://wa.me/923359018136?text=${cartdata()}`, '_blank');
  }

  // [id, img, title, desc, salePrice, oldPrice/original price]
  const vegetables = {
    p12:["12","images/vegetables/potato.webp","Potato(Aloo) 1kg","","50",""],
    p10:["10","images/vegetables/onion.webp","Onion(Pyaz) 1kg","","90",""],
    p7:["7","images/vegetables/ginger.webp","Ginger(Adrak) 500g","","180",""],
    p6:["6","images/vegetables/garlic.webp","Garlic(Lehsan) china 500g","","300",""],
    p14:["14","images/vegetables/tomato.webp","Tomato 1kg","Mix sizes","130",""],
    p9:["9","images/vegetables/lemon.webp","Lemon(Nimbu) 500g","","100",""],
    p17:["17","images/vegetables/dhania.webp","Coriander (Dhania) gathi","","30",""],
    p21:["21","images/vegetables/podina.webp","Mint (Podina) gathi","","20",""],
    p8:["8","images/vegetables/greenchilli.webp","Green Chilli 250g","","60",""],
    p11:["11","images/vegetables/peas.webp","Peas(Matar) 1kg","","80",""],
    p2:["2","images/vegetables/carrot.webp","Carrot(Gajar) 1kg","","70",""],
    p15:["15","images/vegetables/turnip.webp","Turnip (Shaljam) 1kg","","70",""],
    p3:["3","images/vegetables/cauliflower.webp","Cauliflower(Gobi) 1kg","","70",""],
    p1:["1","/images/vegetables/cabbage.webp","Cabbage(Band gobi) 1kg", "","70",""],
    p4:["4","images/vegetables/cocumber.webp","Cocumber Kheera 1kg","","100",""],
    p13:["13","images/vegetables/reddish.webp","Reddish(Muli) 1kg","","80",""],
    p20:["20","images/vegetables/palak.webp","Spinach (Palak) gathi","","60",""],
    p22:["22","images/vegetables/saag.webp","Saag gathi","","60",""],
    // p16:["16","images/vegetables/bhindi.webp","Okra (bhindi) 1kg","","370",""],
    p18:["18","images/vegetables/freshbeans.webp","Fresh beans 1kg","","200",""],
    // p19:["19","images/vegetables/kaddu.webp","Kaddu 1kg","","200",""],
    p23:["23","images/vegetables/shimla.webp","Shimla Mirch 1kg","","320",""],
    // p24:["24","images/vegetables/tinde.webp","Tinde 1kg","","150",""],
    // p25:["25","images/vegetables/karele.webp","Karele 1kg","5kg price: 300","70",""],
    p5:["5","images/vegetables/ganderi.webp","Ganderi 1kg","","180",""],


  };

   const fruits = {
    p101:["101","/images/fruits/1.webp","Orange Kinow 12 pieces", "","350",""],
    p102:["102","/images/fruits/2.webp","Apple Kala-kulu 1kg", "","640",""],
    p103:["103","/images/fruits/3.webp","Amrood 1kg", "","320",""],
    p104:["104","/images/fruits/4.webp","Banana (Kela) Small Size Half Dozen", "","180",""],

  };
  const snacks = {
    p201:["201","/images/snacks/popcorn.webp","PopCorn(Desi) 500g", "","150",""],
    p202:["202","/images/snacks/popcorn_american.webp","PopCorn(American) 500g", "","220",""],
    p203:["203","/images/snacks/samosa_patti.webp","Samosa Sheets 250g ", "1-Bite samosa sheets","120",""],
    p204:["204","/images/snacks/roll_patti.webp","Roll Sheets  250g", "Square shaped roll sheets","120",""],
    p205:["205","/images/snacks/pakori.webp","Pakori 500g", "","200",""],



  };
  const dryfruits = {
    p301:["301","/images/dryfruits/akhrot.webp","Whole Akhrot(china) 500g ", "","450",""],
    p302:["302","/images/dryfruits/almonds.webp","Almonds Giri 250g", "","800",""],
    p303:["303","/images/dryfruits/anjeer.webp","Anjeer 500g", "","1300",""],
    // p304:["304","/images/dryfruits/boxkhajoor.webp","Khajoor box", "Fresh","100",""],
    p305:["305","/images/dryfruits/chuhara.webp","Chuhara 1kg", "","550",""],
    p315:["315","/images/dryfruits/whitechuhara.webp","Chuhara white 1kg", "","750",""],
    p306:["306","/images/dryfruits/iranikhajoor.webp","Irani Khajoor 1kg", "","480",""],
    p307:["307","/images/dryfruits/kaalikhajoor.webp","Mazafati Khajoor 1kg", "Soft black khajoor","820",""],
    p308:["308","/images/dryfruits/kaju.webp","Kaju 250g", "","900",""],
    p309:["309","/images/dryfruits/kajuroasted.webp","Roasted Kaju 250g", "","900",""],
    p310:["310","/images/dryfruits/khopra.webp","Khopra 500g", "","800",""],
    p311:["311","/images/dryfruits/kishmish.webp","Kishmish(Mewa) 500g", "","680",""],
    //p312:["312","/images/dryfruits/mongphali.webp","Peanut (MongPhali) 1kg", "Big size","1200",""],
    p313:["313","/images/dryfruits/pista.webp","Pista(Whole) 250g", "","950",""],
    p314:["314","/images/dryfruits/roastedchane.webp","Roasted Chane 1kg", "","620",""],

  };
  const masalaandothers = {
    p411:["411","/images/masalaandothers/11.webp","Namak 1kg", "","30",""],
    p412:["412","/images/masalaandothers/12.webp","Red Mirch powder 250g", "","200",""],
    p413:["413","/images/masalaandothers/13.webp","Haldi powder 250g", "","200",""],
    p414:["414","/images/masalaandothers/14.webp","Chaat Masala 250g", "","140",""],
    p410:["410","/images/masalaandothers/zeera.webp","White Zeera 1kg", "","1300",""],    
    p401:["401","/images/masalaandothers/darchini.webp","Dar Chini 500g", "","650",""],
    p402:["402","/images/masalaandothers/drydhania.webp","Dry Dhania 500g", "","350",""],
    p403:["403","/images/masalaandothers/greenelaichi.webp","Green Elaichi Premium 50g", "","900",""],
    p404:["404","/images/masalaandothers/gur.webp","Gur Desi 1kg", "","250",""],
    p405:["405","/images/masalaandothers/imli.webp","Imli 500g", "","260",""],
    p406:["406","/images/masalaandothers/kaalielaichi.webp","Black Elaichi 50g", "","300",""],
    p407:["407","/images/masalaandothers/kaalimirch.webp","Black Mirch 250g", "","750",""],
    p408:["408","/images/masalaandothers/long.webp","Long 250g", "","800",""],
    p409:["409","/images/masalaandothers/sonf.webp","Sonf 500g", "","350",""],

  };

  const dairy = {
    p501:["501","/images/dairy/1.webp","Olper's Milk 1L", "","360","370"],
    p502:["502","/images/dairy/2.webp","Omung Milk 1L", "","290","300"],
    p503:["503","/images/dairy/3.webp","Olper's Cream 200ml", "","220","230"],
    p504:["504","/images/dairy/4.webp","Nurpur Butter 200g", "","800",""],
    p505:["505","/images/dairy/5.webp","Blue Band 100g", "","200",""],
    p506:["506","/images/dairy/6.webp","Adam's Cheese Cheddar 200g", "","600",""],
    p507:["507","/images/dairy/7.webp","Adams Buffalo Mozzarella Cheese 200g", "","670",""],
    p508:["508","/images/dairy/8.webp","Nestle Yogurt 400g", "","270",""],
    p509:["509","/images/dairy/9.webp","Nestle Everyday Powder - Original 350g", "","735","745"],
    p5010:["5010","/images/dairy/10.webp","Olper's Full Cream Milk Ecolean 250ml","", "95",""],
    p5011:["5011","/images/dairy/11.webp","Dairy Omung Milk 225ml", "","65","70"],
    p5012:["5012","/images/dairy/12.webp","Nestle Milkpak Dairy Whipping Cream Sweetened 200ml", "","240","250"],
    p5013:["5013","/images/dairy/13.webp","Haleeb Cremyum 200ml", "","160",""],
    p5014:["5014","/images/dairy/14.webp","Haleeb Cream 200ml", "","205","210"],
    p5015:["5015","/images/dairy/15.webp","Nestle Milk Pack Yogurt Pouch 450g", "","220","230"],
    p5016:["5016","/images/dairy/16.webp","Adam's Butter Salted 100g", "","370",""],
    p5017:["5017","/images/dairy/17.webp","Nido Full Cream Milk Powder 375g", "","980","1000"],
    p5018:["5018","/images/dairy/18.webp","Nestle Bunyad Powder Pouch 260g", "","540",""],
    p5019:["5019","/images/dairy/19.webp","Olper's Full Cream Milk Powder Pouch 390g", "","1080","1100"],
    p5020:["5020","/images/dairy/20.webp","Olper's Tarka Asli Desi Ghee 1kg", "","2700",""],
    p5021:["5021","/images/dairy/21.webp","Adams Pure Desi Ghee 1Kg", "","2700",""],


  };

const grains = {
    p601:["601","/images/grains/1.webp","Ghiza Chakki Atta 5kg", "","820","840"],
    p617:["617","/images/grains/17.webp","Chakki Atta 1kg", "","160",""],
    p618:["618","/images/grains/18.webp","Fine Atta 1kg", "","160",""],
    p602:["602","/images/grains/2.webp","Premium Chana Dal (Dal Chana Supreme Premium) 1kg", "","320","328"],
    p603:["603","/images/grains/3.webp","Premium Moong Dal (Dal Moong Premium) 1kg", "","485","498"],
    p604:["604","/images/grains/4.webp","Premium Masoor Dal (Dal Masoor Premium) 1kg", "","320","328"],
    p605:["605","/images/grains/5.webp","Premium Mash Dal (Dal Mash Premium) 1kg", "","840","858"],
    p606:["606","/images/grains/6.webp","White Chickpeas (Safed Chana) 9mm 1kg", "","550","588"],
    p607:["607","/images/grains/7.webp","Premium Black Chickpeas (Chana Black Premium) 1kg", "","300","308"],
    p608:["608","/images/grains/8.webp","Red Kidney Beans (Lal Lobia) 1kg", "","500","538"],
    p609:["609","/images/grains/9.webp","Bajra 1kg", "","140","158"],
    p610:["610","/images/grains/10.webp","Ghiza Semolina (Suji) 500g", "","140","145"],
    p611:["611","/images/grains/11.webp","Baisan Chickpea Flour (Besan) 1kg", "","270",""],
    p612:["612","/images/grains/12.webp","Sugar 1kg", "","160",""],
    p613:["613","/images/grains/13.webp","Desi Gurr 1kg", "","250",""],
    p614:["614","/images/grains/14.webp","Rafhan Corn Flour 275g", "","160","175"],
    p615:["615","/images/grains/15.webp","Daal Masoor Whole (Black Masoor) 500g", "","135","148"],
    p616:["616","/images/grains/16.webp","Daal Moong 500g", "","225","248"],

    p619:["619","/images/grains/19.webp","Guard Ultimate Basmati Rice (Chawal) 1kg", "","550","570"],
    p620:["620","/images/grains/20.webp"," Guard Ultimate Basmati Rice (Ultimate Basmati Chawal) 5kg", "","2700","2845"],
    p621:["621","/images/grains/21.webp"," Mughal Classic Basmati rice (Daaghi Rice) 5kg", "","1600","1700"],
    

  };

  const oilghee = {
    p701:["701","/images/oilghee/1.webp","Dalda Cooking Oil Pouch 1 Ltr", "","580","590"],
    p702:["702","/images/oilghee/2.webp","Mezan Cooking Oil 1Litre Pouch", "","560","585"],
    p703:["703","/images/oilghee/3.webp","Mezan Ghee Poly Bag 1kg", "","560","585"],
    p704:["704","/images/oilghee/4.webp","Tullo Cooking Oil Pouch 1L", "","545","553"],
    p705:["705","/images/oilghee/5.webp","Tullo Banaspati Pouch 1kg", "","545","553"],
    p706:["706","/images/oilghee/6.webp","Eva Cooking Oil Pillow Pouch 1l", "","560","585"],
    p707:["707","/images/oilghee/7.webp","Eva Cooking Oil Stand Up 1l", "","580","605"],
    p708:["708","/images/oilghee/8.webp","Dalda Manpasand Cooking Oil Pouch 900ml", "","495","504"],
    p709:["709","/images/oilghee/9.webp","Canolive Oil Poly Pouch 1 Ltr", "","650","669"],
    p710:["710","/images/oilghee/10.webp","Canolive Banaspati 1 Kg Pouch", "","570","585"],
    p711:["711","/images/oilghee/11.webp","Dalda Banaspati Ghee Pouch 1kg", "","580","590"],
    p712:["712","/images/oilghee/12.webp","Dalda Cooking Oil Bottle 3L", "","1830","1850"],
    p713:["713","/images/oilghee/13.webp","Dalda Manpasand Banaspati Pouch 900g", "","495","504"],
    p714:["714","/images/oilghee/14.webp","Eva Banaspati 1Kg Pouch", "","560","585"],


  };

  const beverages = {
    p801:["801","/images/beverages/1.webp","Tapal Danedar Black Tea 170g", "","370","380"],
    p802:["802","/images/beverages/2.webp","Lipton Yellow Label Tea - 170g", "","390","400"],
    p803:["803","/images/beverages/3.webp","Vital Tea 170Gm Box", "","380",""],
    p804:["804","/images/beverages/4.webp","Nestle Nescafe Classic Coffee Jar 50g", "","1130","1150"],
    p805:["805","/images/beverages/5.webp","Qarshi Jam E Shirin 800ml", "","480","550"],
    p806:["806","/images/beverages/6.webp","Tang Orange Pouch 375g (Makes 3l)", "","330","350"],
    p807:["807","/images/beverages/7.webp","Pepsi PET 1.5l", "","170","200"],
    p808:["808","/images/beverages/8.webp","Coca Cola Bottle 1.5l", "","180","200"],
    p809:["809","/images/beverages/9.webp","Sprite Bottle 1.5l", "","180","200"],
    p810:["810","/images/beverages/10.webp","7Up PET 1.5l", "","180","200"],
    p811:["811","/images/beverages/11.webp","Aquafina Water PET 1.5l", "","80","90"],
    p812:["812","/images/beverages/12.webp","Cola Next 1.5l", "","160","170"],
    p813:["813","/images/beverages/13.webp","Fizup Next Drink Bottle 1.5l", "","160","170"],
    p814:["814","/images/beverages/14.webp","Rango Next 1500ml", "","160","170"],
    p815:["815","/images/beverages/15.webp","Tang Mango Pouch 375g (Makes 3l)", "","330","350"],
    p816:["816","/images/beverages/16.webp","Tang Lemon & Pepper Pouch 375g (Makes 3l)", "","330","350"],
    p817:["817","/images/beverages/17.webp","Nestle Nesfruta Mango Fruit Drink 1000ml", "","240",""],
    p818:["818","/images/beverages/18.webp","Sting Berry Blast Energy Drink PET 500ml", "","110","120"],


  };

  const saucenoodles = {
    p901:["901","/images/saucenoodles/1.webp","Shangrila Ketchup Pouch 800g", "","345","360"],
    p902:["902","/images/saucenoodles/2.webp","Shangrila Garlic Chili Sauce Pouch 800g", "","345","360"],
    p903:["903","/images/saucenoodles/3.webp","Youngs Mayonnaise Pouch 500ml", "","345","360"],
    p904:["904","/images/saucenoodles/4.webp","Knorr Instant Noodles Chatt Patta 110g", "","85","90"],
    p905:["905","/images/saucenoodles/5.webp","Knorr Instant Noodles Chicken 110g", "","90",""],
    p906:["906","/images/saucenoodles/6.webp","National Tomato Ketchup 400g", "","190","220"],
    p907:["907","/images/saucenoodles/7.webp","National Chilli Garlic Sauce 400g", "","190","220"],
    p908:["908","/images/saucenoodles/8.webp","Shangrila Soya Sauce 275ml", "","135","145"],
    p909:["909","/images/saucenoodles/9.webp","Shangrila Chilli Sauce 275ml", "","140","155"],
    p910:["910","/images/saucenoodles/10.webp","Shangrila Synthetic Vinegar 275ml", "","110","120"],
    p911:["911","/images/saucenoodles/11.webp","National Classic Mayo Pouch 200ml", "","145","160"],

  };

  const personalcare = {
    p1001:["1001","/images/personalcare/1.webp","Safeguard Pure White Soap 103g", "","130",""],
    p1002:["1002","/images/personalcare/2.webp","Lux Allure Bar Velvet Glow 130g", "","150",""],
    p1003:["1003","/images/personalcare/3.webp","Lifebuoy Shampoo Onion 175ml", "","355","370"],
    p1004:["1004","/images/personalcare/4.webp","Sunsilk Shampoo Hairfall Solution 185ml", "","435","450"],
    p1005:["1005","/images/personalcare/5.webp","Head & Shoulders Silky Black Shampoo 185ml", "","470",""],
    p1006:["1006","/images/personalcare/6.webp","Colgate ToothPaste Herbal 45g", "","70","75"],
    p1007:["1007","/images/personalcare/7.webp","Sensodyne Toothpaste Rapid Action 70g", "","365","380"],
    p1008:["1008","/images/personalcare/8.webp","Glow & Lovely Multivitamin Cream", "","140","150"],
    p1009:["1009","/images/personalcare/9.webp","Ponds Bright Beauty Local Face Wash ", "","470","490"],
    p1010:["1010","/images/personalcare/10.webp","Pond's Triple Vitamin Moisturizing Lotion 100ml", "","330","350"],
    p1011:["1011","/images/personalcare/11.webp","Palmolive Naturals Refreshing Glow Bar Soap 98g", "","110","120"],
    p1012:["1012","/images/personalcare/12.webp","Palmolive Naturals Hydrating Glow Bar Soap 98g", "","110","120"],
    p1013:["1013","/images/personalcare/13.webp","Palmolive Naturals Moisturizing Glow Bar Soap 98g", "","110","120"],
    p1014:["1014","/images/personalcare/14.webp","Lux Allure Fresh Glow 128g", "","150",""],
    p1015:["1015","/images/personalcare/15.webp","Lux Allure Bar Rose Glow 130g", "","150",""],
    p1016:["1016","/images/personalcare/16.webp","Safeguard Body Soap Lemon Fresh 103g", "","130",""],
    p1017:["1017","/images/personalcare/17.webp","Pantene Anti Hairfall Shampoo 185ml", "","450",""],
    p1018:["1018","/images/personalcare/18.webp","Clear Shampoo Cool Black Shine 185ml", "","450","470"],


  };

  const housecleaning = {
    p1101:["1101","/images/housecleaning/1.webp","Surf Excel Detergent Powder 1 kg", "","530",""],
    p1102:["1102","/images/housecleaning/2.webp","Ariel Detergent Washing Powder Downy 1kg", "","580",""],
    p1103:["1103","/images/housecleaning/3.webp","Bonus Tristar Detergent Washing Powder 1000g", "","220","230"],
    p1104:["1104","/images/housecleaning/4.webp","Max Lemon Dishwash Liquid 275ml", "","150","165"],
    p1105:["1105","/images/housecleaning/5.webp","Vim Active Dishwashing Liquid Lime 450ml", "","235","250"],
    p1106:["1106","/images/housecleaning/6.webp","Vim Green Long Bar 260g", "","60","70"],
    p1107:["1107","/images/housecleaning/7.webp","Lemon Max Dishwash Long Bar 265g", "","70","80"],
    p1108:["1108","/images/housecleaning/8.webp","Harpic Toilet Cleaner Lavender 450ml", "","450","475"],
    p1109:["1109","/images/housecleaning/9.webp","Kingtox All Insect Killer Spray 300ml", "","450","468"],
    p1110:["1110","/images/housecleaning/10.webp","Brite Antibacterial Washing Powder 1kg", "","600","620"],
    p1111:["1111","/images/housecleaning/11.webp","Sunlight 2in1 Washing Powder Pink - 2kg (Clean & Jasmine Fresh)", "","480","500"],


  };

  const packedspices = {
    p1201:["1201","/images/packedspices/1.webp","Shan Karahi Ghost Masala 50g", "","135","150"],
    p1202:["1202","/images/packedspices/2.webp","Shan Tandoori Masala 50g", "","135","150"],
    p1203:["1203","/images/packedspices/3.webp","Shan Biryani Recipe Masala 50g", "","135","150"],
    p1204:["1204","/images/packedspices/4.webp","Shan Special Chaat Masala Masala 85g", "","165","180"],
    p1205:["1205","/images/packedspices/5.webp","Shan Nihari Masala 100g", "","270","290"],
    p1206:["1206","/images/packedspices/6.webp","Shan Sindhi Biryani Masala 55g", "","135","150"],
    p1207:["1207","/images/packedspices/7.webp","Shan Haleem Masala 50g", "","135","150"],
    p1208:["1208","/images/packedspices/8.webp","Shan Punjabi Yakhni Pilau Masala 50g", "","135","150"],
    p1209:["1209","/images/packedspices/9.webp","Shan Chicken Masala 50g", "","135","150"],
    p1210:["1210","/images/packedspices/10.webp","Shan Shami Kabab Masala 50g", "","135","150"],
    p1211:["1211","/images/packedspices/11.webp","Shan Kofta Masala 50g", "","135","150"],
    p1212:["1212","/images/packedspices/12.webp","Shan Tikka Boti Masala 45g", "","135","150"],
    p1213:["1213","/images/packedspices/13.webp","Shan Fish Masala 50g", "","135","150"],
    p1214:["1214","/images/packedspices/14.webp","Shan Seekh Kabab Masala 45g", "","135","150"],
    p1215:["1215","/images/packedspices/15.webp","Shan Chappli Kabab Masala 100g", "","135","150"],
    p1216:["1216","/images/packedspices/16.webp"," Shan Paya Masala 50g", "","135","150"],
    p1217:["1217","/images/packedspices/17.webp","National Masala Quorma 50g", "","135","150"],
    p1218:["1218","/images/packedspices/18.webp","National Chaat Masala 45g", "","110","120"],
    p1219:["1219","/images/packedspices/19.webp","National Refined Salt 800g", "","60","70"],
    p1220:["1220","/images/packedspices/20.webp","National Chicken Tikka Masala 40g", "","135","150"],
    p1221:["1221","/images/packedspices/21.webp","National Pulao Masala 70g", "","135","150"],
    p1222:["1222","/images/packedspices/22.webp","National Haleem Masala 50g", "","135","150"],
    p1223:["1223","/images/packedspices/23.webp","National Bombay Biryani Karachi Khaas 70g", "","135","150"],
    p1224:["1224","/images/packedspices/24.webp","National Biryani Masala 39g", "","135","150"],
    p1225:["1225","/images/packedspices/25.webp","National Nihari Karachi Khaas 56g", "","135","150"],
    p1226:["1226","/images/packedspices/26.webp","National Sindhi Biryani Masala 41g", "","135","150"],
    p1227:["1227","/images/packedspices/27.webp","National Qeema Masala 50g", "","135","150"],
    p1228:["1228","/images/packedspices/28.webp","National Chicken Tandoori 40g", "","135","150"],
    p1229:["1229","/images/packedspices/29.webp","National Broast Masala 97g", "","135","150"],
    p1230:["1230","/images/packedspices/30.webp","National Pulao Biryani Recipe Mix Masala 50g", "","135","150"],
    p1231:["1231","/images/packedspices/31.webp","National Paya Masala 39g", "","135","150"],
    p1232:["1232","/images/packedspices/32.webp","National Chapli Kabab Masala 72g", "","135","150"],
    p1233:["1233","/images/packedspices/33.webp","National Masala Malai Boti 50g", "","135","150"],
    p1234:["1234","/images/packedspices/34.webp","National Tikka Boti Masala 44g", "","140","150"],

  };

  const ramzanpack = {
    p1301:["1301","/images/ramzanpack/1.webp","Ramzan Pack 1","Rice 1kg\nSugar 2kg\nTea 200g\nDaal chana 500g\nWhite chana 500g\nBesan 500g\nKhajoor 500g\nJam Shireen 500ml\nBanaspati ghee 1x\nRed mirch 100g\nNamak 800g","2500",""],
    p1302:["1302","/images/ramzanpack/1.webp","Ramzan Pack 2","Rice 5kg\nSugar 2kg\nTea 200g\nDaal chana 1kg\nWhite chana 500g\nBesan 1kg\nKhajoor 1kg\nJam Shireen 800ml\nBanaspati ghee 2x\nRed mirch 200g\nSalt 800g\nSawaiyan 2 packs","5000",""],
    p1303:["1303","/images/ramzanpack/1.webp","Ramzan Pack 3","Rice 5kg\nSugar 2kg\nTea 200g\nDaal chana 1kg\nWhite chana 1kg\nDaal masoor 1kg\nRed lobia 500g\nBesan 1kg\nKhajoor 1kg\nJam Shireen 800ml\nBanaspati ghee 5x\nRed mirch 200g\nSalt 800g\nSawaiyan 1 pack","7200",""],

  };

   const allProducts = [
  ...Object.values(vegetables),
  ...Object.values(fruits),
  ...Object.values(snacks),
  ...Object.values(dryfruits),
  ...Object.values(masalaandothers),
  ...Object.values(dairy),
  ...Object.values(grains),
  ...Object.values(oilghee),
  ...Object.values(beverages),
  ...Object.values(saucenoodles),
  ...Object.values(personalcare),
  ...Object.values(housecleaning),
  ...Object.values(packedspices),
  ...Object.values(ramzanpack),


];

const isCartEmpty = Object.values(cart).every(product => parseInt(product[1]) === 0);
  return (
    <div className='main-container'>
      {/* <div className='store-name'>Sauda Mart</div>
      <div className='tag-line'>Fresh vegtables & Dry Fruits</div>
      <div className='tag-line'>کم قیمت میں معیاری سامان</div>
    */}

    <header className="main-header">
  <div className="header-content">
    <h1 className='store-name'>Delhi Savemart</h1>
    <span className='tag-line-en'></span>
    <div className='tag-line-ur'>کم قیمت میں معیاری سامان</div>
  </div>
</header>
      <div className='instructions'>
        <div className='english-instructions'>
          - Place your order before 8pm. Order will be delivered next-day.<br />
          - Only Rs. 100 delivery charges.<br />
          - Minimum Order: Rs. 500.<br /><br />
          <b>Delivery Locations:</b><br />

          &emsp;&emsp;- Within 6km of Saddar Mall Road (for orders under 5000).<br />
          &emsp;&emsp;- All over Rawalpindi & Islamabad for orders of Rs. 5000 or more!<br />
        </div>
        {/* <div className='urdu-instructions'>
         - آپ کا آرڈر اگلے روز ڈیلیور کر دیا جائے گا۔<br />

        </div> */}
        <div style={{textAlign:'center', fontWeight:'bold', fontSize:'12px'}}>
        <br />
          *** For bulk discounted orders all over Rwp/Isl, contact at whatsapp 0335-9018136***<br />

          </div>

      </div>
<div className='line'></div>
<div>
      <OrderSummary cartDict={cart} onUpdate={updateCart}/>

</div>
      <a className='whatsapp-button'
      // href={"https://wa.me/923359018136?text=" + cartdata()}
      onClick={handleWhatsappClick}
      // target="_blank"
      rel="noreferrer"
      >
              <span style={{paddingRight:'10px'}}>Send your order</span>

        <svg 
        viewBox="0 0 24 24" 
        width="20" 
        height="20" 
        fill="currentColor"
      >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
      </a>
<div className='line'></div>
<div className="search-wrapper">
  <div className='search-wrapper-child'>
    <input
      type="text"
      placeholder="Search for product"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
    {searchTerm && (
      <span 
        onClick={() => setSearchTerm("")} 
      >
        ×
      </span>
    )}
  </div>
</div>
  
{!searchTerm && (<div className='navigation-tags'>
  <span className='nav-label'>Go To:</span>
  <div className='tags-container'>
  <span 
        className={`nav-tag ${activeTab === 'vegetables' ? 'active' : ''}`} 
        onClick={() => setActiveTab('vegetables')}
      >🥦 Vegetables</span>    
  <span 
        className={`nav-tag ${activeTab === 'fruits' ? 'active' : ''}`} 
        onClick={() => setActiveTab('fruits')}
      >🍎 Fruits</span>    
    
  <span 
        className={`nav-tag ${activeTab === 'snacks' ? 'active' : ''}`} 
        onClick={() => setActiveTab('snacks')}
      >🍿 Snacks</span>

  <span 
        className={`nav-tag ${activeTab === 'dryfruits' ? 'active' : ''}`} 
        onClick={() => setActiveTab('dryfruits')}
      >🥜 Dry Fruits</span>
  <span 
        className={`nav-tag ${activeTab === 'masaleandothers' ? 'active' : ''}`} 
        onClick={() => setActiveTab('masaleandothers')}
      >🌶️ Masale</span>
   <span 
        className={`nav-tag ${activeTab === 'dairy' ? 'active' : ''}`} 
        onClick={() => setActiveTab('dairy')}
      >🥛 Dairy</span> 

   <span 
        className={`nav-tag ${activeTab === 'grains' ? 'active' : ''}`} 
        onClick={() => setActiveTab('grains')}
      >🌾 Grains  </span> 


<span 
        className={`nav-tag ${activeTab === 'oilghee' ? 'active' : ''}`} 
        onClick={() => setActiveTab('oilghee')}
      >🧴 Oil Ghee  </span> 
<span 
        className={`nav-tag ${activeTab === 'beverages' ? 'active' : ''}`} 
        onClick={() => setActiveTab('beverages')}
      >🥤 Beverages </span> 

<span 
        className={`nav-tag ${activeTab === 'saucenoodles' ? 'active' : ''}`} 
        onClick={() => setActiveTab('saucenoodles')}
      >🥫 Sauce & Noodles </span>    

<span 
        className={`nav-tag ${activeTab === 'personalcare' ? 'active' : ''}`} 
        onClick={() => setActiveTab('personalcare')}
      >🧼 Personal Care</span>  

<span 
        className={`nav-tag ${activeTab === 'housecleaning' ? 'active' : ''}`} 
        onClick={() => setActiveTab('housecleaning')}
      >🧹 House cleaning</span>
<span 
        className={`nav-tag ${activeTab === 'packedspices' ? 'active' : ''}`} 
        onClick={() => setActiveTab('packedspices')}
      >🌶️ Brand Masale</span>      
        
<span 
        className={`nav-tag ${activeTab === 'ramzanpack' ? 'active' : ''}`} 
        onClick={() => setActiveTab('ramzanpack')}
      >🌙 Ramzan Packs</span>        
        </div>
</div>)}



    {/* <div className='line'></div> */}

{searchTerm !== "" ? (
  /* --- SEARCH VIEW --- */
  <div className='category-section'>
    <div className='category-heading'>Showing results for "{searchTerm}"</div>
    <div className='product-section'>
      {allProducts.filter(p => {
          if (!p[2]) return false;
    
    const title = p[2].toLowerCase();
    const query = searchTerm.toLowerCase();

    // 1. Check for exact partial match (always show these)
    if (title.includes(query)) return true;

    // 2. Check for fuzzy match (handles typos)
    // We split title into words so "Potaot" matches "Potato(Aloo)"
    const words = title.split(/[\s()]+/); // Splits by space and brackets
    const isSimilar = words.some(word => getSimilarity(word, query) > 0.5); 

    return isSimilar;
  })
  .sort((a, b) => {
    // Optional: Sort results so exact matches appear at the top
    const aMatch = a[2].toLowerCase().includes(searchTerm.toLowerCase());
    const bMatch = b[2].toLowerCase().includes(searchTerm.toLowerCase());
    return bMatch - aMatch;
  })
        
        .map((product) => (
          <ProductCard
            key={product[0]}
            id={product[0]}
            image={product[1]}
            title={product[2]}
            description={product[3]}
            price={product[4]}
            originalPrice={product[5]}            
            quantity={cart[product[0]] ? cart[product[0]][1] : 0}
            onUpdate={updateCart}
          />
        ))}
    </div>
  </div>
) : (
  /* --- NORMAL TABS VIEW --- */
  <>
      {activeTab === 'vegetables' &&(<div className='category-section' id="vegetables">
        <div className='category-heading'>Vegetables</div>
          
          <div className='product-section'>
          {Object.values(vegetables).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return (
            <ProductCard
              key={pId} 
              id={pId} // Essential for React performance
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}
              quantity={currentQty}              
              onUpdate={updateCart}
            />);
          })}
          </div>

      </div>)}

      {/* <div className='line'></div> */}
      {activeTab === 'fruits' && (<div className='category-section' id="fruits">
        <div className='category-heading'>Fruits</div>
          
          <div className='product-section'>
          {Object.values(fruits).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]} 
              quantity={currentQty}             
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}

      {/* <div className='line'></div> */}
      {activeTab === 'snacks' && (<div className='category-section' id="snacks">
        <div className='category-heading'>Snacks</div>
          
          <div className='product-section'>
          {Object.values(snacks).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}

       {/* <div className='line'></div> */}
      {activeTab === 'dryfruits' && (<div className='category-section' id="dryfruits">
        <div className='category-heading'>Dry Fruits</div>
          
          <div className='product-section'>
          {Object.values(dryfruits).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}   
              quantity={currentQty}           
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}
      {/* <div className='line'></div> */}
      {activeTab === 'masaleandothers' && (<div className='category-section' id="masaleandothers">
        <div className='category-heading'>Masale and others</div>
          
          <div className='product-section'>
          {Object.values(masalaandothers).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}   
              quantity={currentQty}           
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)} 

{activeTab === 'dairy' && (<div className='category-section' id="dairy">
        <div className='category-heading'>Dairy</div>
          
          <div className='product-section'>
          {Object.values(dairy).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}

{activeTab === 'grains' && (<div className='category-section' id="grains">
        <div className='category-heading'>Grains</div>
          
          <div className='product-section'>
          {Object.values(grains).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}

  {activeTab === 'oilghee' && (<div className='category-section' id="oilghee">
    <div className='category-heading'>Oil & Ghee</div>
      
      <div className='product-section'>
      {Object.values(oilghee).map((product) => {
        const pId = product[0];
        const currentQty = cart[pId] ? cart[pId][1] : 0;
        return(
        <ProductCard 
          key={pId} // Essential for React performance
          id={pId}
          image={product[1]}
          title={product[2]}
          description={product[3]}
          price={product[4]}
          originalPrice={product[5]}  
          quantity={currentQty}            
          onUpdate={updateCart}
        />);
})}
      </div>

  </div>)}



 {activeTab === 'beverages' && (<div className='category-section' id="beverages">
        <div className='category-heading'>Beverages</div>
          
          <div className='product-section'>
          {Object.values(beverages).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}

 {activeTab === 'saucenoodles' && (<div className='category-section' id="saucenoodles">
        <div className='category-heading'>Sauce & Noodles</div>
          
          <div className='product-section'>
          {Object.values(saucenoodles).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}  


 {activeTab === 'personalcare' && (<div className='category-section' id="personalcare">
        <div className='category-heading'>Personal Care</div>
          
          <div className='product-section'>
          {Object.values(personalcare).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)} 

 {activeTab === 'housecleaning' && (<div className='category-section' id="housecleaning">
        <div className='category-heading'>House cleaning</div>
          
          <div className='product-section'>
          {Object.values(housecleaning).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}      

 {activeTab === 'packedspices' && (<div className='category-section' id="packedspices">
        <div className='category-heading'>Brand Masale</div>
          
          <div className='product-section'>
          {Object.values(packedspices).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)} 


{activeTab === 'ramzanpack' && (<div className='category-section' id="ramzanpack">
        <div className='category-heading'>Ramzan Packs</div>
          
          <div className='product-section'>
          {Object.values(ramzanpack).map((product) => {
            const pId = product[0];
            const currentQty = cart[pId] ? cart[pId][1] : 0;
            return(
            <ProductCard 
              key={pId} // Essential for React performance
              id={pId}
              image={product[1]}
              title={product[2]}
              description={product[3]}
              price={product[4]}
              originalPrice={product[5]}  
              quantity={currentQty}            
              onUpdate={updateCart}
            />);
})}
          </div>

      </div>)}
  </>
)}


      
    </div>
  );
}

export default App;
